/* This Source Code Form is subject to the terms of the Mozilla Public
* License, v. 2.0. If a copy of the MPL was not distributed with this
* file, You can obtain one at http://mozilla.org/MPL/2.0/. */




export function generate() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random()*16|0;
        const v = c == 'x' ? r : (r&0x3|0x8);
        return v.toString(16);
    });
}


/** WEBPACK FOOTER **
 ** ./src/util/uuid.js
 **/